export default [
  {
    id: 1,
    game_name: "墨杀攻速单职业",
    ip: "攻速单职〃",
    line: "装备全爆模式★",
    detail: "装备全爆攻速拉满耐玩",
    qq: "攻速高爆╊",
    play_tags: [
      "火龙"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 2,
    game_name: "刀藏诛※仙专属╊",
    ip: "诛仙专属必体验╊",
    line: "◆金币·全爆",
    detail: "金币全爆专属追梦挑战魔王追梦〃",
    qq: "灬专属★打宝",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.95"
    ]
  },
  {
    id: 3,
    game_name: "玄策沉默专属〃",
    ip: "※新三职沉默·",
    line: "自动挂机稳",
    detail: "自动挂机※装备全爆冲╊",
    qq: "复古沉默",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 4,
    game_name: "钜峰复古沉默",
    ip: "█复古沉默版",
    line: "━长久低消赞助★",
    detail: "低消赞助极品加◆五终极宝宝打金服",
    qq: "▁怀旧复古▃",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 5,
    game_name: "展锋飞◆羽沉默",
    ip: "三职沉默▃",
    line: "热门自动回收╊",
    detail: "▲自动回收装备全爆开战◆",
    qq: "散人推荐〃",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 6,
    game_name: "▁衍月灵猫传奇▃",
    ip: "176版",
    line: "▲小极品版稳◆",
    detail: "小极品版挂机打宝极品加五长久耐玩▃",
    qq: "小█极品〃",
    play_tags: [
      "小极品"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 7,
    game_name: "文狸墨竹特戒",
    ip: "◆特色特·戒玩法",
    line: "█超福利魔王",
    detail: "灬福利魔王装★备全爆刚开服",
    qq: "福利◆BOSS",
    play_tags: [
      "小极品"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 8,
    game_name: "※未休魅影骷髅王·",
    ip: "超爽经◆典长服",
    line: "无榜无坑散人服",
    detail: "※无榜无坑货币全爆全套技能散人来追梦",
    qq: "◆长期·耐玩",
    play_tags: [
      "小极品"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 9,
    game_name: "※踵武仙剑沉默",
    ip: "经典仙剑沉默",
    line: "泡点顶级首战区〃",
    detail: "泡点顶级灵石回收活动不断开战",
    qq: "活动丰富▃",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 10,
    game_name: "碧影王█土无限刀〃",
    ip: "灬无限刀版",
    line: "▁爆五转高爆▃",
    detail: "五转高爆秘境奇遇燃★",
    qq: "━奇遇秘境★",
    play_tags: [
      "小极品"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 11,
    game_name: "残照迷失单职业★",
    ip: "▁迷失单职",
    line: "装备全爆",
    detail: "装备全爆巡航█挂机免费终极爆〃",
    qq: "迷失高爆",
    play_tags: [
      "迷失"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 12,
    game_name: "━归鸦无限刀★",
    ip: "※无限刀版必体验",
    line: "全屏█吸怪〃",
    detail: "全屏吸怪巡航挂机刚开服",
    qq: "▲全屏吸怪◆",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 13,
    game_name: "暮雪渝乐复古▃",
    ip: "灬176★版版",
    line: "灬赤月终极",
    detail: "◆赤月终极免费畅·玩三职平衡必玩",
    qq: "赤月复古★",
    play_tags: [
      "复古"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 14,
    game_name: "霁月攻※速单职业╊",
    ip: "超攻速单职★",
    line: "八大陆图路线",
    detail: "八大陆图自动回收散人服╊",
    qq: "八大陆",
    play_tags: [
      "迷失"
    ],
    versions: [
      "1.95"
    ]
  },
  {
    id: 15,
    game_name: "枯荷高爆神器",
    ip: "灬高爆神器",
    line: "※火爆装备全打",
    detail: "装备全打魔王高※爆等级好升长久服╊",
    qq: "▁BOSS高爆",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.95"
    ]
  },
  {
    id: 16,
    game_name: "▲啼鹃变速狂刀◆",
    ip: "变速狂刀▃",
    line: "━会员到底服★",
    detail: "█会员到底上线激战终极切割",
    qq: "▁切割狂刀▃",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 17,
    game_name: "█血池火龙三职业",
    ip: "长久火龙三职系统",
    line: "小怪终极爆★",
    detail: "▲小怪终极年兽必爆三职特色新区首战◆",
    qq: "火龙打宝╊",
    play_tags: [
      "火龙"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 18,
    game_name: "裂空合击",
    ip: "经典合击新区╊",
    line: "灬法道起步",
    detail: "法道起步装备保值教主全爆冲〃",
    qq: "合击█推荐〃",
    play_tags: [
      "合击"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 19,
    game_name: "▁断猿沉默专属",
    ip: "◆沉默·专属",
    line: "灵笼福利首战区▃",
    detail: "灬灵笼福利★称号切割",
    qq: "█沉默切割",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 20,
    game_name: "※锈刀微变三职业·",
    ip: "微变三职区",
    line: "灬新法★师群刷",
    detail: "法师群刷道士辅助战士爆发长久服",
    qq: "◆三职·平衡",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 21,
    game_name: "百破灵◆猫沉默",
    ip: "灵猫沉默▃",
    line: "火爆六大陆图╊",
    detail: "※六大陆图任务成长爽·",
    qq: "多大陆〃",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 22,
    game_name: "怒雷天█之冰雪〃",
    ip: "▁火天之冰雪路线",
    line: "兄弟攻沙长久耐玩",
    detail: "灬兄弟攻沙三职热血裁决追梦首战区",
    qq: "情怀推荐",
    play_tags: [
      "冰雪"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 23,
    game_name: "灬无定赤月大极品",
    ip: "赤月极品真耐玩",
    line: "█泡点五十",
    detail: "泡点五十装备鉴定真充魔王",
    qq: "鉴定◆追梦",
    play_tags: [
      "大极品"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 24,
    game_name: "━黄泉复古三职业★",
    ip: "爽◆176版",
    line: "赤月终█极专服〃",
    detail: "※赤月终极极品加八金币打宝激情开荒",
    qq: "▲金币复古◆",
    play_tags: [
      "复古"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 25,
    game_name: "无常沉默三职业〃",
    ip: "沉默三职★",
    line: "装备全爆服",
    detail: "◆装备全爆巡·航挂机打金服",
    qq: "沉默高爆",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 26,
    game_name: "刀域火龙",
    ip: "灬火龙三职",
    line: "◆新真·充可打",
    detail: "真充可打生肖成长技能强化骨灰来开荒★",
    qq: "灬火龙★进阶",
    play_tags: [
      "火龙"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 27,
    game_name: "墨染微变单职业★",
    ip: "※经典微变单职·",
    line: "三大◆陆图稳",
    detail: "三大陆图泡点※升级终极魔王╊",
    qq: "※微变单职",
    play_tags: [
      "复古"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 28,
    game_name: "▲素霓战神三职业◆",
    ip: "战神三职",
    line: "紫名高爆★",
    detail: "紫名高爆生肖开天爆▃",
    qq: "战神打宝",
    play_tags: [
      "战神"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 29,
    game_name: "琴台神器专属",
    ip: "神器█专属〃",
    line: "灬爽货币可打玩法",
    detail: "▲货币可打永久回收满级五百燃◆",
    qq: "神器追梦★",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 30,
    game_name: "▁邪瞳无限刀▃",
    ip: "攻速无限★",
    line: "▲泡点三百稳◆",
    detail: "泡点三百等级切割开战╊",
    qq: "等级█切割〃",
    play_tags: [
      "迷失"
    ],
    versions: [
      "1.95"
    ]
  },
  {
    id: 31,
    game_name: "※墨杀神器单职业",
    ip: "神器单职玩法",
    line: "超爽十元起步〃",
    detail: "十元起步长期保值多阶魔王散人必玩",
    qq: "神器高爆▃",
    play_tags: [],
    versions: []
  },
  {
    id: 32,
    game_name: "※朱砂复古沉默·",
    ip: "超复古沉默模式▃",
    line: "灬自动★拾取",
    detail: "█自动拾取免费挂机刚开服",
    qq: "◆复古·开荒",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 33,
    game_name: "█霁月火龙单职业",
    ip: "新火※龙单职╊",
    line: "材料全爆首战区",
    detail: "※材料全爆巡航挂机免费终极散人服·",
    qq: "火龙高爆╊",
    play_tags: [
      "火龙"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 34,
    game_name: "暮雪沉█默三职业〃",
    ip: "沉默三职散人首选",
    line: "▁长久装备回收▃",
    detail: "装备回收书页强化三职争锋冲",
    qq: "━职业平衡★",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 35,
    game_name: "▁残照狂徒迷失",
    ip: "狂徒◆迷失",
    line: "切割转生路线▃",
    detail: "切割转生宠物进化█高图怪密散人必玩〃",
    qq: "█宠物成长",
    play_tags: [
      "迷失"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 36,
    game_name: "━断猿摸金传奇★",
    ip: "█摸金传奇",
    line: "搜打撤离",
    detail: "搜打撤离秘境◆事件快速成型爽",
    qq: "创新玩法",
    play_tags: [
      "小极品"
    ],
    versions: [
      "1.76"
    ]
  },
  {
    id: 37,
    game_name: "裂空神器专属",
    ip: "灬神器专★属玩法",
    line: "※超十元起步",
    detail: "◆十元起步·小怪全爆",
    qq: "▁白嫖神器",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 38,
    game_name: "归鸦沉※默单职业╊",
    ip: "▁超爽沉默单职",
    line: "免费◆顶赞",
    detail: "灬免费顶赞四大群攻货币可打必玩",
    qq: "灬公益★单职",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 39,
    game_name: "灬锈刀专属神器",
    ip: "※专属神器·",
    line: "█火神技神宠新区",
    detail: "神技神宠※黄金交易冲╊",
    qq: "自由交易",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 40,
    game_name: "枯荷180小极品",
    ip: "180版╊",
    line: "━拾取鉴定服★",
    detail: "拾取鉴定神塔免费技能九重长久服〃",
    qq: "▁极品鉴定▃",
    play_tags: [
      "小极品"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 41,
    game_name: "墨染微变三职业〃",
    ip: "微变三职★",
    line: "▁十元起步路线",
    detail: "▲十元起步小怪全爆耐玩◆",
    qq: "灬微变高爆",
    play_tags: [
      "复古"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 42,
    game_name: "▁血池攻速无限刀▃",
    ip: "攻速无限爽",
    line: "▲三大陆图◆",
    detail: "三大陆图魔王速刷专属成长骨灰来开荒",
    qq: "攻速█无限刀〃",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 43,
    game_name: "黄泉火龙大极品",
    ip: "◆真火·龙极品",
    line: "双号开荒╊",
    detail: "灬双号开荒惊★喜必爆首战区",
    qq: "火龙极品〃",
    play_tags: [
      "火龙"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 44,
    game_name: "※邪瞳专属单职业·",
    ip: "专属单职区〃",
    line: "经典泡点升级",
    detail: "泡点升级货币可打长期耐玩散人来追梦▃",
    qq: "◆专属·单职",
    play_tags: [
      "沉默"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 45,
    game_name: "朱砂战神三职业▃",
    ip: "铭文三职真耐玩",
    line: "灬火爆血石恢复",
    detail: "血石恢复无赞无榜魔龙技能耐玩",
    qq: "铭文复古★",
    play_tags: [
      "复古"
    ],
    versions: [
      "1.80"
    ]
  },
  {
    id: 46,
    game_name: "书斋迷█失神器〃",
    ip: "迷失◆神器",
    line: "▁十元起步服▃",
    detail: "※十元起步小怪高爆燃",
    qq: "━迷失神器★",
    play_tags: [
      "迷失"
    ],
    versions: [
      "1.85"
    ]
  },
  {
    id: 47,
    game_name: "※无常专属神器",
    ip: "▲专属神器系统◆",
    line: "热门七大陆图路线",
    detail: "七大陆图攻速█九十无限刀版爆〃",
    qq: "攻速神器",
    play_tags: [
      "神器"
    ],
    versions: [
      "1.95"
    ]
  }
];
